/**
 * Coordinates a single invalid-session recovery per page lifetime.
 * Concurrent requests can all observe the same failed refresh; only the
 * first one may clear state and send the browser to the recovery route.
 */

let recoveryClaimed = false;

export function claimSessionRecovery(): boolean {
  if (recoveryClaimed) return false;
  recoveryClaimed = true;
  return true;
}

/** Test-only reset; production sessions reset naturally on page reload. */
export function __resetSessionRecoveryForTests(): void {
  recoveryClaimed = false;
}

/** A successful bootstrap or login establishes a fresh recovery boundary. */
export function resetSessionRecovery(): void {
  recoveryClaimed = false;
}
